import { wrapAsDerivedFromMeasurementsConfig as wrap } from 'Components/Worksheets/Core/Helpers/configHelpers';

const getDerivedFromMeasurementsConfig = (prefix: string) => ({
  [`${prefix}.Preparation.PreparedSampleMass`]: wrap([
    `${prefix}.Preparation.TareMass`,
    `${prefix}.Preparation.TareAndSampleMass`,
  ]),
});

export default getDerivedFromMeasurementsConfig;
